export default __webpack_public_path__ + "static/icon-1-f759d79e877daedc91ddf2ab83a051eb.png";